const normalizeLocks = (locks) => {
  return (locks || []).reduce((acc, lock) => {
    if (!lock || lock.idPreSale === undefined || lock.idPreSale === null) {
      return acc;
    }

    return {
      ...acc,
      [lock.idPreSale]: {
        idPreSale: lock.idPreSale,
        userId: lock.userId,
        userName: lock.userName,
        lockDate: lock.lockDate
      }
    };
  }, {});
};

export default {
  SET_LOCKS(state, locks) {
    state.locks = normalizeLocks(locks);
  },

  REMOVE_LOCK(state, idPreSale) {
    if (idPreSale === undefined || idPreSale === null) {
      return;
    }

    const locks = { ...state.locks };
    delete locks[idPreSale];
    state.locks = locks;
  }
};
